module.exports = "<img ng-src=../images/branding/logo@2x.png ng-srcset=\"../../images/branding/logo@2x.png 2x, ../../images/branding/logo.png 1x\"> ";